import { createContext, useCallback, useContext, useEffect, useState } from 'react';

import noop from 'lodash/noop';

import { DialogLoader } from '../../../components/Dialog/DialogLoader';
import { prewarmRecaptcha } from '../../../services/firebase';
import type { SignInPlatform } from '../../../services/types';
import type { Credentials } from '../useHandleAuth';

type SignUpWizardContextData = {
  provider?: SignInPlatform;
  error?: string;
  credentials?: Credentials;
  loading?: boolean;
};

export const SignUpWizardContext = createContext<
  SignUpWizardContextData & { updateContextData: (data: Partial<SignUpWizardContextData>) => void }
>({
  provider: undefined,
  error: undefined,
  loading: false,
  updateContextData: noop,
});

export const useSignUpWizardContext = () => {
  return useContext(SignUpWizardContext);
};

export const SignUpWizardProvider = ({ children }: { children: React.ReactNode }) => {
  const [contextData, setContextData] = useState<SignUpWizardContextData>({ provider: undefined, loading: false });

  useEffect(() => {
    void prewarmRecaptcha();
  }, []);

  const updateContextData = useCallback((data: Partial<SignUpWizardContextData>) => {
    setContextData((prev) => ({ ...prev, ...data }));
  }, []);

  return (
    <SignUpWizardContext.Provider value={{ ...contextData, updateContextData }}>
      <DialogLoader isProcessing={contextData.loading} />
      {children}
    </SignUpWizardContext.Provider>
  );
};
